import { render, staticRenderFns } from "./ChatView.vue?vue&type=template&id=97130dc0&scoped=true&"
import script from "./ChatView.vue?vue&type=script&lang=js&"
export * from "./ChatView.vue?vue&type=script&lang=js&"
import style0 from "./ChatView.vue?vue&type=style&index=0&id=97130dc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97130dc0",
  null
  
)

export default component.exports